import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const CARoute = ({ children }) => {
  const { isAuthenticated, loadingAuth, userType, isSubscriptionExpired } = useAuth();
  const location = useLocation();

  if (loadingAuth) {
    return <div>Loading authentication...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userType !== 'ca') {
    return <Navigate to="/dashboard" replace />;
  }

  if (isSubscriptionExpired && !location.pathname.startsWith('/settings')) {
    return <Navigate to="/settings?tab=subscription" replace />;
  }

  return children;
};

export default CARoute;
